import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  upload: {
    defaultMessage: 'Upload',
    description: 'Text for button to upload a file',
    id: 'uM73sI',
  },
  fileTypeNotSupported: {
    defaultMessage: 'File type not supported. Accepted types: {acceptedTypes}',
    description: 'Error message when file type is not supported',
    id: 'vU3NT+',
  },
  fileSizeExceedsLimit: {
    defaultMessage: 'File size exceeds the maximum limit of {maxSize} MB',
    description: 'Error message when file size exceeds the limit',
    id: '0FMiK1',
  },
});
